import React, { HTMLProps } from "react";

import './style.scss';

interface IProps extends HTMLProps<HTMLInputElement> {}

const ToggleSwitch = (props: IProps) => (
  <label className="B-betslip-toggle-switch">
    <input type="checkbox" {...props} />
    <span className="B-slider" />
  </label>
);

export default ToggleSwitch;
